import { emptyArr } from 'util/arrays'
import { base } from './base'

export const selectIds = state => base(state).ids || emptyArr
